import dayjs from 'dayjs';
import * as advancedFormat from 'dayjs/plugin/advancedFormat';
import { classnames } from 'tailwindcss-classnames';

import { COLORS } from '../../constants/colors';

dayjs.extend(advancedFormat);

export const DEFAULT_THEME = {
  backgroundColor: COLORS.snow,
  textColor: COLORS.liquorice,
};

// handles the color theme changes when the header is not completely overlapping the article header
export const handleHeaderColorBreakpoint = (breakpointRef, headerRef) => {
  if (!breakpointRef?.current || !headerRef?.current) return false;

  if (
    breakpointRef.current?.getBoundingClientRect()?.bottom <=
    headerRef.current?.offsetHeight
  ) {
    return true;
  }

  return false;
};

// handles getting the correct colors based on props and the current state of the header
export const getHeaderTheme = ({
  isExpanded,
  isHeaderOverColorBreakpoint,
  showFreddieInverse,
  showOverlayMode,
  theme,
}) => {
  let isFreddieInverse = showFreddieInverse;
  let { backgroundColor, textColor } = theme;
  let hamburgerColor = textColor;
  let freddieForegroundColor = textColor;
  let freddieBackgroundColor = backgroundColor;

  if (showOverlayMode) {
    freddieBackgroundColor = '#000';
  }

  if (isHeaderOverColorBreakpoint) {
    textColor = COLORS.liquorice;
    backgroundColor = COLORS.snow;
    hamburgerColor = COLORS.liquorice;
    freddieForegroundColor = COLORS.liquorice;
    freddieBackgroundColor = COLORS.snow;
    isFreddieInverse = false;
  }

  if (isExpanded) {
    hamburgerColor = COLORS.liquorice;
  }
  return {
    backgroundColor,
    freddieBackgroundColor,
    freddieForegroundColor,
    hamburgerColor,
    isFreddieInverse,
    textColor,
  };
};

export const getCurrentTime = () => {
  return dayjs().format('dddd, MMMM Do');
};

export const nonMinifiedHeaderClasses = classnames(
  'lg:h-[91px]',
  'lg:py-8.5',
  'sm:h-[91px]',
  'sm:py-8.5',
  'py-5',
  'h-[71px]',
);
export const minifiedHeaderClasses = classnames(
  'lg:h-[73px]',
  'py-5',
  'h-[71px]',
);
